var alertTriggersList = {
	caption: "Liste der Alert-Trigger",
	noResultsMessage: "Keine Ergebnisse gefunden",
	actions: "Aktionen",
	trigger: {
		dateTime: "Erstellungsdatum",
		limits: "Limits",
		limitAbove: "Oberes Limit",
		limitBelow: "Unteres Limit"
	},
	security: {
		name: "Name",
		isin: "ISIN",
		lastPrice: "Letzter Kurs",
		lastPriceDateTime: "Datum/Zeit",
		assetClass: "Anlageklasse",
		exchange: "Handelsplatz"
	}
};
var de = {
	alertTriggersList: alertTriggersList
};

export { alertTriggersList, de as default };
